/**
 * Path prefixes where global snackbars (API alerts + useCustomSnackbar) are suppressed.
 * A path matches if it equals the entry or starts with `entry + '/'`.
 * Align with auth-related GET routes in portal-api/jti/Route.Config.js when adding entries.
 */
export const SNACKBAR_SUPPRESSED_PATHS = ['/login', '/signup', '/register/invitation']

function pathMatchesBase(pathname, basePath) {
  return pathname === basePath || pathname.startsWith(`${basePath}/`)
}

/**
 * @param {string} [pathname]
 * @returns {boolean}
 */
export default function shouldSuppressSnackbar(pathname) {
  if (!pathname || typeof pathname !== 'string') return false

  return SNACKBAR_SUPPRESSED_PATHS.some(base => pathMatchesBase(pathname, base))
}
